import Axios from "axios";
import {
    SET_HRM_EMPLOYEE_TYPE_LIST,
    UNSET_HRM_EMPLOYEE_TYPE_LIST,
  } from "@/store/mutation-types";
import { saveUpdateHrmEmployeeType, getHrmEmployeeTypeList } from "@/store/api";
// initial state
const state = {
  getHrmEmployeeTypeList: [],
};

const getters = {
  getHrmEmployeeTypeList(state) {
    return state.getHrmEmployeeTypeList;
  },
};

const mutations = {
  [SET_HRM_EMPLOYEE_TYPE_LIST](state, data) {
    state.getHrmEmployeeTypeList = data;
  },
  [UNSET_HRM_EMPLOYEE_TYPE_LIST](state) {
    state.getHrmEmployeeTypeList = [];
  },

};

const actions = {

  saveUpdateHrmEmployeeType({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateHrmEmployeeType, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getHrmEmployeeTypeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmEmployeeTypeList, data)
        .then(function (response) {
          commit('SET_HRM_EMPLOYEE_TYPE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_HRM_EMPLOYEE_TYPE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
